import React, { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  Grid,
  Typography,
  Modal,
  ThemeProvider,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { basicTheme } from "../../themes/customTheme";
import SnackBars from "../reusableComponents/SnackBar";

const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  px: 6,
  boxShadow: 24,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflowY: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
};

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
//   textField: {
//     "& .MuiInputBase-input": {
//       border: "none", // Remove the border
//     },
//     "& .MuiInput-underline:before": {
//       border: "none", // Remove the underline
//     },
//     "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
//       border: "none", // Remove the underline on hover
//     },
//   },
// }));

// const ButtonStyle = styled(Button)({
//   backgroundColor: "#2D6A4F",
//   color: "white",
//   textTransform: "none",
//   borderRadius: "1rem",
//   fontSize: "16px",
//   fontWeight: "600",
//   minWidth: "140px",
//   maxWidth: "150px",
//   height: "54px",
// });

// const CancelButtonStyle = styled(Button)({
//   backgroundColor: "white",
//   color: "#2D6A4F",
//   textTransform: "none",
//   borderRadius: "1rem",
//   fontSize: "16px",
//   fontWeight: "600",
//   minWidth: "140px",
//   maxWidth: "150px",
//   height: "54px",
// });

export default function AddFormModal({
  openAddModal,
  handleClose = () => {},
  setFormSnackBarMessage = () => {},
  setFormSnackBarType = () => {},
  setReload = () => {},
  setOpenSuccessBox = () => {},
  setSuccessMessage = () => {},
  setOpenSuccessBoxType = () => {},
  languages = [],
}) {
  // const classes = useStyles();
  const [formName, setFormName] = useState("");
  const [formStatus, setFormStatus] = useState("");
  const [addFormSnackBar, setAddFormSnackBar] = useState(false);
  const [addFormSnackBarMessage, setAddFormSnackBarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const basicError = {
    formName: "",
    formStatus: "",
    formIcon: "",
    projects: "",
  };
  const [addFormSnackBarType, setAddFormSnackBarType] = useState("success");
  const [errors, setErrors] = useState(basicError);
  const formStatusList = ["Active", "Inactive"];
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState(null);
  const [projectList, setProjectList] = useState([{ id: "", name: "" }]);

  const isValidCsv = (csv) => /^[^,]+(,[^,]+)*$/.test(csv.trim());

  const handleCloseByClearIcon = () => {
    setErrors(basicError);
    setFormName("");
    setFormStatus("");
    setProjects("");
    setAddFormSnackBar(false);
    setAddFormSnackBarType("success");
    setAddFormSnackBarMessage("");
    setFormSnackBarType("");
    setFormSnackBarMessage("");
    handleClose();
  };

  return (
    <Modal open={openAddModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid
            container
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: "white",
              marginTop: 2,
              paddingTop: 2,
              // paddingTop: 4,
            }}
          >
            <Grid item xs={11}>
              <Typography variant="h4" style={{ marginBottom: 10 }}>
                Add Form
              </Typography>
            </Grid>
            <Grid
              item
              xs={1}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <CloseRoundedIcon
                // className={classes.closeBtnStyle}
                onClick={handleCloseByClearIcon}
              />
            </Grid>
          </Grid>
          <Grid>
            <Button variant="contained" href="/new-form">
              New Form
            </Button>
            <Button
              variant="contained"
              href="/import-form"
              style={{ marginLeft: 10 }}
            >
              Import Form
            </Button>
          </Grid>

          <Grid
            container
            item
            sm={12}
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              backgroundColor: "white",
              justifyContent: "center",
              display: "flex", // Add display:flex to create a flex container
            }}
          >
            <Grid item sx={{ margin: "30px" }}>
              <Button variant="contained" name="cancel" onClick={handleClose}>
                Cancel
              </Button>
            </Grid>
            {addFormSnackBar && (
              <SnackBars
                open={addFormSnackBar}
                handleClose={() => setAddFormSnackBar(false)}
                severity={addFormSnackBarType}
                message={addFormSnackBarMessage}
                autoHideDuration={6000}
                vertical="bottom"
                horizontal="center"
                position="absolute"
              />
            )}
          </Grid>

          {/* <BackDropLoader loading={loading} />
          <BackDropLoader loading={isLoading} /> */}
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
